import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Modal mask centered className="modal_portal" key="m1" width={1600} title="Укрепи свое здоровье за 30 минут в день" open={activeModal === 'health'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Укрепи свое здоровье за 30 минут в день</h2>
                        </div>
                        <div className='text_content'>
                            <p>Современный образ жизни часто связан с сидячей работой, малоподвижным образом жизни и недостаточной физической активностью. Это может привести к различным заболеваниям и проблемам со здоровьем. Однако, даже небольшие усилия в повседневной жизни могут существенно улучшить физическую форму и здоровье.</p>
                            <h3>Вот несколько простых способов, как поддерживать физическую активность в повседневной жизни, не напрягаясь:</h3>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: null,
                                            image: 'hls_image_01_06_03.jpeg',
                                            text: 'Поднимайтесь по лестнице вместо использования лифта: каждый раз, когда вы сталкиваетесь с выбором между лифтом и лестницей, выбирайте лестницу. Подъем по лестнице является отличной кардиотренировкой, укрепляет мышцы и увеличивает выносливость'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_04.jpeg',
                                            text: 'Сделайте определенное количество шагов в день: старайтесь делать не менее 10 000 шагов в день. Это может быть легко достигнуто, если вы ходите по работе, делаете прогулки во время обеда или вечерней прогулки. Просто ставьте перед собой цель каждый день сделать не менее 10 000 шагов'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_05.jpeg',
                                            text: 'Занимайтесь йогой или пилатесом: йога и пилатес - это замечательные упражнения, которые могут быть выполнены дома или в специальных залах. Они помогают укрепить мышцы, улучшить гибкость и осанку'
                                        },{
                                            title: null,
                                            image: 'hls_image_01_06_06.jpeg',
                                            text: 'Находите время на ежедневную прогулку: если у вас есть возможность сделать ежедневную прогулку, не упускайте ее. Это может быть утренняя или вечерняя прогулка, которая позволяет получить свежий воздух и привнести физическую активность в вашу жизнь'
                                        },
                                        {
                                            title: null,
                                            image: 'hls_image_01_06_07.jpeg',
                                            text: 'Используйте велосипед вместо автомобиля: если у вас есть возможность, используйте велосипед вместо автомобиля для коротких поездок. Это отличный способ улучшить физическую форму и сохранить здоровье'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} className='column' >
                                        <none />
                                        {item.image ? 
                                            <img src={`${IMAGES}/banners/${item.image}`} />
                                        :
                                            null
                                        }
                                        <div className='info'>  
                                            {item.title ? 
                                                <p className='title'>{item.title}</p>
                                            :
                                                null
                                            }
                                            <p className='text'>{item.text}</p>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/health.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <section className='container_full --hls_item_6'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Физическая активность</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый сон</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый сон</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_01_06_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Физическая активность — это ключ к здоровому образу жизни. Многие люди думают, что для достижения хорошей физической формы необходимо заниматься спортом не менее двух-трех раз в неделю. Однако на самом деле даже минимальные усилия в ежедневной физической активности могут сделать большую разницу для здоровья человека.</p>
                                                <h3>Вот несколько причин, почему важно заниматься физической активностью ежедневно, даже если это минимальные усилия:</h3>
                                                <ul>
                                                    <li><none />Улучшение настроения: физическая активность способствует выделению эндорфинов, которые являются естественным антидепрессантом. Эндорфины улучшают настроение, уменьшают уровень стресса и тревожности</li>
                                                    <li><none />Улучшение сна: регулярная физическая активность помогает улучшить качество сна и повысить продолжительность сна</li>
                                                    <li><none />Укрепление иммунной системы: физическая активность укрепляет иммунную систему, что помогает организму бороться с инфекциями и заболеваниями</li>
                                                    <li><none />Улучшение физической формы: даже минимальные ежедневные физические  упражнения могут помочь улучшить физическую форму, увеличить мышечную силу и гибкость</li>
                                                    <li><none />Предотвращение заболеваний: физическая активность может помочь предотвратить многие заболевания, такие как ожирение, диабет, высокое кровяное давление, болезни сердца и другие</li>
                                                </ul>
                                                <p>Таким образом, заниматься физической активностью ежедневно очень важно для поддержания здоровья и хорошего самочувствия. Даже если у вас очень мало свободного времени, вы можете найти возможности для минимальной физической активности, такие как прогулки, подъем по лестнице, зарядка утром или вечером. Каждый шаг в сторону здорового образа жизни будет иметь положительный эффект на ваше здоровье и благополучие.</p>
                                            </div>
                                            <section className='container shadow default_padding next'>
                                                <div className='next_container' onClick={() => setActiveModal('health')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_01_06_02.jpeg)`}}>

                                                                </div>
                                                            </div>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>Укрепи свое здоровье за 30 минут в день</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};